import { logger } from '@/lib/logger';
import { getInstallmentType } from '@/components/Interstitials/InstallmentInterstitial/utils';

const logFPTIWhenDropdownClicked = () => {
  logger.fpti('installment_dropdown_clicked', {
    state_name: 'installment',
    transition_name: 'prepare_installment_dropdown_clicked',
  });
};

/**
 * Log Installment type of IC2B when drop down is clicked in FPTI
 *
 * @param installmentData - The properties for the button.
 */
const logFPTIWhenDropdownClickedWithIC2B = installmentData => {
  const maxTerm = installmentData[installmentData.length - 1]?.term;
  const installmentType = getInstallmentType(installmentData, maxTerm);
  logger.fpti('installment_dropdown_clicked', {
    installment_type: installmentType,
    max_installment_term: maxTerm,
    state_name: 'installment',
    transition_name: 'prepare_installment_dropdown_clicked',
  });
};

export { logFPTIWhenDropdownClicked, logFPTIWhenDropdownClickedWithIC2B };
